import { QueryClient } from '@tanstack/react-query';

/**
 * T-257 — wspólny klient React Query dla danych REST DocuWatcher. Bez odświeżania przy powrocie do
 * okna (widoki bilansu są ciężkie, a zmiany i tak robi ten sam użytkownik), jedna ponowna próba
 * i 30 s świeżości, żeby przełączanie widoków nie odpytywało API za każdym razem.
 */
export const QUERY_STALE_TIME_MS = 30_000;

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: QUERY_STALE_TIME_MS,
        retry: 1,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: false,
      },
    },
  });
}

export const queryClient = createQueryClient();
